import { ChangeDetectionStrategy, Component } from '@angular/core';
import { selectAppDirection } from '../../../@store/app.selectors';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-main-layout-wrapper',
  templateUrl: './main-layout-wrapper.component.html',
  styleUrls: ['./main-layout-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayoutWrapperComponent {
  public direction$ = this.store.select(selectAppDirection);

  constructor(private store: Store) {}
}
